import {Button, Input} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import styled from 'styled-components'
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import axios from "axios"
import { endpoint } from "../../config"
import { updateQueryTitle, updateVideos } from "../../reduxStore"

export default function SearchBar(props){
  const dispatch = useDispatch()
  const query = useSelector(state => state.query)

  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    dispatch(updateQueryTitle(searchQuery))
  }, [searchQuery])

  const handleChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const handleSearch = async (e) => {
    let url = `${endpoint}?title=${query.title}`
    if(query.contentRating) url += `&contentRating=${query.contentRating.replace(/\+$/g, '%2B')}`
    if(query.genres.length) url += `&genres=${query.genres.join(',')}`
    // console.log(url)
    const res = await axios.get(url)

    // const res = await axios.get(`${endpoint}?title=${searchQuery}`)
    dispatch(updateVideos(res.data.videos))
  }

  return (
    <StyledDiv>
      <StyledInput type="text" placeholder="Search" onChange={handleChange} id='search-input' />
      <SearchButton onClick={handleSearch}>
        <SearchIcon style={{width: "1.25rem"}}/>
      </SearchButton>
    </StyledDiv>
  )
}

const SearchButton = styled.button`
  background: #414141;
  border: 1px solid #616161;
  border-left: none;
  color: #818181;
  display: inline-block;
  flex: 1;
`

const StyledInput = styled.input`
  display: inline-block;
  background: #121212;
  color: white;
  border: 1px solid #616161;
  padding: 0 0.5rem;
  flex: 8;
`

const StyledDiv = styled.div`
  display: flex;
  width: 50%;
  height: 2.2rem;
  margin: 0 auto;
`